import { connect } from 'react-redux';
import Component from '../components/js/CategoryContents';
import { ITopStates } from '../store';
const mapStateToProps = (state: ITopStates) => {
  const category = state.globalNavigation.currentCategory;
  const currentCategory = state.newsFeedTab.subCategories.find(subCategory => {
    return subCategory.isCurrent;
  });
  const subCategoryId = currentCategory ? currentCategory.id : undefined;

  return {
    category,
    subCategoryId
  };
};

export default connect(mapStateToProps, {})(Component);
